import {useMutation, useQuery} from "react-query";
import axios from "axios";
import {PagedSearchParams} from "@atiautomacao/ati-ui-library";
import {TicketCategory} from "../../../Shared/Types/TicketCategory";

const apiUrl = "api/ticket-category";
const timeout = 30000;

const handleAccepted = (res: any) => res.data;
const handleRejected = (err: any) => console.error("Error fetching data:", err);

export const CreateTicketCategory = () => {
    return useMutation((data: TicketCategory) => axios.post(apiUrl, data, {timeout}).then(handleAccepted, handleRejected));
};

export const UpdateTicketCategory = () => {
    return useMutation((data: TicketCategory) => axios.put(apiUrl, data, {timeout}).then(handleAccepted, handleRejected));
};

export const DeleteTicketCategory = () => {
    return useMutation((id: number) => axios.delete(`${apiUrl}/${id}`, {timeout}).then(handleAccepted, handleRejected));
};

export const FindByIdTicketCategory = (id: number) => {
    return useQuery(
        ['findbyid-ticketcategory', id],
        () => axios.get(`${apiUrl}/${id}`, {timeout}).then(handleAccepted, handleRejected),
        {enabled: !!id}
    );
};

export const FindAllTicketCategory = () => {
    return useQuery(
        'findall-ticketcategory',
        () => axios.get(apiUrl, {timeout}).then(handleAccepted, handleRejected)
    );
};

export const SearchTicketCategory = (pagedSearchParams: PagedSearchParams) => {
    const params = pagedSearchParams ? pagedSearchParams.toURLSearchParams() : null;

    return useQuery(
        ["search-ticketcategory", pagedSearchParams],
        () => axios.get(`${apiUrl}/search`, {params, timeout}).then(handleAccepted, handleRejected)
    );
};
